import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query";

import { QueryKey } from "pages/register/types/queryKey";
import { AuthTransaction } from "pages/register/types/authTransaction";
import { OktaError } from "../../../../../types/oktaError/oktaError";

import { API_GET_TRANSACTION_URL } from "constants/apiUrls";

import getApiClient from "lib/apiClient/getApiClient";

function useGetTransaction(
  stateToken: string,
  options?: Partial<UseQueryOptions<AuthTransaction | null, OktaError>>,
): UseQueryResult<AuthTransaction | null, OktaError> {
  const apiClient = getApiClient();

  return useQuery({
    queryKey: [`${QueryKey.Transaction}-${stateToken}`],
    queryFn: async () => {
      if (!stateToken) {
        return Promise.resolve(null);
      }

      const response = await apiClient(API_GET_TRANSACTION_URL, {
        method: "POST",
        body: JSON.stringify({ stateToken }),
      });

      const data = await response.json();

      return response.ok ? Promise.resolve(data) : Promise.reject(data);
    },
    retry: false,
    ...options,
  });
}

export default useGetTransaction;
